import Common from '../../Common';

interface UpdateBody {
	paused: string
}

export interface CreateBody {
	paused: string | number
	penalty: string | number
	wrapuptime: string | number
	pbx_user_id: id
}

const Members = class extends Common {
	browse = (queueId: id) =>
		this.get(`/queue/${queueId}/member`)

	update = (queueId: id, queueMemberId: id, data: UpdateBody) =>
		this.patch(`/queue/${queueId}/member/${queueMemberId}`, data)

	delete = (queueId: id, queueMemberId: id) =>
		this.doDelete(`/queue/${queueId}/member/${queueMemberId}`)

	create = (queueId: id, data: CreateBody) =>
		this.post(`/queue/${queueId}/member`, data)
}

export default Members;
